import { render, staticRenderFns } from "./addLang.vue?vue&type=template&id=7a948b62&scoped=true"
import script from "./addLang.vue?vue&type=script&lang=js"
export * from "./addLang.vue?vue&type=script&lang=js"
import style0 from "./addLang.vue?vue&type=style&index=0&id=7a948b62&prod&lang=scss&scoped=true"
import style1 from "./addLang.vue?vue&type=style&index=1&id=7a948b62&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a948b62",
  null
  
)

export default component.exports